import '../stylesheets/embedded'

import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import "@fortawesome/fontawesome-free/css/all.css"
